import { z } from 'zod';

export const BrandQuestionDataSchema = z.object({
    category: z.string().min(1, 'Category is required'),
    topic: z.string().min(1, 'Topic is required'),
    value: z.string().min(1, 'Question is required'),
});
export type BrandQuestionData = z.infer<typeof BrandQuestionDataSchema>;


export const BrandQuestionRowSchema = z.object({
    id: z.coerce.number(),
}).extend(BrandQuestionDataSchema.shape);
export type BrandQuestionRow = z.infer<typeof BrandQuestionRowSchema>;
